import * as KatalMetrics from '@amzn/katal-metrics'
import KatalMetricsDriverSushi from '@amzn/katal-metrics-driver-sushi'
import KatalMetricsDriverConsoleLogJson from '@amzn/katal-metrics/lib/driver/KatalMetricsDriverConsoleLogJson'
import KatalMetricsDriverArrayCollector from '@amzn/katal-metrics/lib/driver/KatalMetricsDriverArrayCollector'
import { DOMAIN, REALM, SITE } from '../common/constants'

// eslint-disable-next-line no-console
const metricsConsoleErrorHandler = (err: Error) => console.error(err)

const makeMetricsDriver = (): KatalMetrics.MetricsDriver => {
  if (process.env.NODE_ENV === 'test') {
    const metricsDriver = new KatalMetricsDriverArrayCollector()
    //  Attach to global window object so tests can see it
    ;(window as any).metricsDriver = metricsDriver
    return metricsDriver
  } else if (process.env.NODE_ENV !== 'production') {
    return new KatalMetricsDriverConsoleLogJson()
  } else {
    return new KatalMetricsDriverSushi.Builder().withDomainRealm(DOMAIN['prod'], REALM['us-west-2']).withErrorHandler(metricsConsoleErrorHandler).build()
  }
}

const makePublisher = (): KatalMetrics.Publisher => {
  const metricsDriver = makeMetricsDriver()
  const initialMetricsContext = new KatalMetrics.Context.Builder()
    .withSite(SITE['prod'] || 'FIT')
    .withServiceName('IntroWidgetsAssets')
    .build()
  return new KatalMetrics.Publisher(metricsDriver, metricsConsoleErrorHandler, initialMetricsContext)
}

export const KatalMetricsPublisher = makePublisher()

export const AjaxMetricsPublisher = KatalMetricsPublisher.newChildActionPublisherForMethod('BigTopAjaxService.getNewFeatures')

export const FeedbackModalAjaxCallMetricsPublisher = KatalMetricsPublisher.newChildActionPublisherForMethod('FeedbackModal.ajaxCall')

export const FeedbackModalSubmissionMetricsPublisher = KatalMetricsPublisher.newChildActionPublisherForMethod('FeedbackModal.submission')

export const FeedbackModalMetricsPublisher = KatalMetricsPublisher.newChildActionPublisherChainedForMethod('FeedbackModal')
